import React, { KeyboardEvent, useState } from 'react'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'
import { ButtonIcon } from '../Button/Button'
import { Col } from '../List/Col'

type Props = {
  readonly title?: string
  readonly onBack: () => void
  readonly actionButtons?: React.ReactNodeArray
  readonly onSearch?: (keyword: string) => void
  readonly isShowSearch?: boolean
  readonly searchType?: string
}

const Breadcrumbs: React.VFC<Props> = ({
  title,
  onBack,
  actionButtons,
  onSearch,
  isShowSearch = false,
  searchType,
}) => {
  const [keyword, setKeyword] = useState<string>()

  const handleChange = (keyword: string) => {
    setKeyword(keyword)

  }

  const handleSearch = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key == 'Enter' && onSearch) {
      onSearch(keyword)
    }
  }

  const handleReset = () => {
    setKeyword(null)
    onSearch && onSearch(null)
  }

  return (
    <div className={classNames([styles.Table, styles.Breadcrumbs])}>
      <Col additionalClassNames={[styles.BreadBack]}>
        <ButtonIcon
          additionalClassNames={[styles.IconBreadBack]}
          onClick={onBack}
        />
      </Col>
      <Col additionalClassNames={[styles.BreadLinks]}>{title}</Col>
      {!!actionButtons && (
        <Col additionalClassNames={[styles.BreadButton]}>{actionButtons}</Col>
      )}
      {isShowSearch && (
        <Col>
          <div className={classNames([styles.SearchComment])}>
            <input
              className={classNames([styles.SearchComment])}
              placeholder={`Search ${searchType}`}
              value={keyword ?? ''}
              onChange={(e) => handleChange(e.target.value)}
              onKeyUp={(e) => handleSearch(e)}
            />
            <div
              onClick={handleReset}
              className={classNames([
                styles.IconClose,
                styles.ButtonIcon,
              ])}
              title='Close'
            />
          </div>
        </Col>
      )}
    </div>
  )
}

export default Breadcrumbs
